export function clickOutside(
  node: HTMLElement,
  onEventFunction: () => unknown,
) {
  const handleClick = (event: Event) => {
    const path = event.composedPath()

    if (!path.includes(node)) {
      onEventFunction()
    }
  }

  // If an element that uses use:clickOutside is added through a click event, the new handler will be immediately called. We need to wait for the next tick to add the handler.
  setTimeout(() => {
    document.addEventListener('click', handleClick)
  }, 0)

  return {
    destroy() {
      document.removeEventListener('click', handleClick)
    },
  }
}
